// 定义中文语言包对象
export default {
	lang: {
		back:"返回",
		save:"保存",
		do:"操作",
		select:"查询",
		add:"添加",
		status:"状态",
		confirm:"确认",
		cancel:"取消",
		selectAll:"全选",
		description:"描述",
		getLocation:"坐标拾取",
		theme:{
			tip:'主题切换',
			light:'白色主题',
			dark:"黑色主题",
			orange:"橙色主题"
		},
		date:{
			month:"月",
			week:"周",
			day:'日',
			year:"年",
			unit:'每',
			hour:"时",
			hourUnit:"点",
			second:"秒",
			millisecond:"毫秒",
			startTime:"开始日期",
			endTime:"结束日期",
			loadHour:"分时",
			loadDay:"日总",
			createTime:"创建时间"
		},
		device:{
			add:"新建",
			edit:"编辑",
			search:"搜索",
			del:"删除",
			count:"共",
			deviceTypeTitle:"设备类型",
			deviceGroupTitle:"设备群组",
			deviceModelTitle:"设备型号",
			detail:'详细',
			point:'点位',
			deviceInformation:"设备信息",
			actions:"点位表",
			deviceName:"设备名称",
			deviceNo:"设备代号",
			deviceDescription:"设备描述",
			deviceId:"终端标识",
			status:"活跃状态",
			ver:"协议版本",
			deviceData:"设备实时数据",
			selectDeviceData:"查询实时参数",
			deviceHistory:"设备历史数据",
			deviceHistoryHour:'分时历史数据',
			deviceHistoryday:'每日历史数据',
			deviceHistoryMonth:'每月历史数据',
			activeTime:'通讯时间',
			null:"暂无设备数据",
			deviceUnit:"个",
			dtuId:"上行中继",
			modbusSlaveNo:'从站编号',
			deviceEdit:{
				deviceProp:"设备属性",
				deviceId:"设备编码",
				protocolVersion:"协议版本",
				factoryModelName:"原始型号",
				udpPort:"服务端口",
				dtuDeviceId:"上行中继",
				modbusSlaveNo:"从站编号",
				potentialTransformer:"电压变比",
				currentTransformer:"电流变比",
				intervalMonitor:"监测周期",
				comProtocol:"通讯协议",
				serialPortName:"串口名称",
				baudRate:"波特率",
				dataBit:"数据位",
				stopBit:"停止位",
				parityCheck:"奇偶校验",
				frameCheck:"帧校验",
				broadcastEnable:"监听广播",
				serverAddress:"通讯地址",
				serverPort:"服务端口",
				chargeAmuDeviceId:"充电计量单元",
				dischargeAmuDeviceId:"放电计量单元",
				coa:"公共地址",
				interrogationType:"召唤方式",
				useMultiThreads:"使用多线程",
				pauseTime:"间隔时长",
				cicnaFrequency:"总召唤频率",
				bcpDeviceId:'储能电池舱',
				bcpStackDeviceId:"储能电池堆"
			},
			prop:{
				title:"配置",
				save:"保存配置",
				bizAction:"设备能力",
				amu:{
					title:"辅助计量单元能力配置",
					currentTransformer:"电流变比",
					potentialTransformer:"电压变比",
					ratedPowerCapacity:"额定容量",
					maxDemandActivePower:"最大有功功率需量",
					maxDemandActivePowerTip:"按容收费时，需要有效的参数值，电压变比与电流变比均视为 1；按需收费时，参数值应设置为 0。",
					preservedActivePowerCharge:"充电时预留有功功率",
					protectionActivePower:"放电时保护有功功率",
					broadcastEnable:"多储能柜充放电优先级",
					
					minMaxDemandActivePower:"最小有功功率需量",
					minMaxDemandActivePowerTip:"在按需收费时，有功功率需量的最小值。",
					
					prohibitSimultaneousChargingAndDischarging:"禁止同时充电和放电",
					priorityCharging:"优先充电",
					preferentialDischarge:"优先放电"
				},
				esc:{
					title:"储能一体机能力配置",
					maxActivePowerCharge:"最大充电有功功率",
					minActivePowerCharge:"最小充电有功功率",
					maxActivePowerDischarge:"最大放电有功功率",
					minActivePowerDischarge:"最小放电有功功率",
					maxSoc:"SOC上限",
					minSocGridOn:"并网SOC下限",
					minSocGridOff:"离网SOC下限",
					minSoh:"SOH下限",
					reactivePowerCharge:"充电无功功率",
					reactivePowerDischarge:"放电无功功率",
					maxDurationStandby:"最大待机时长",
					standbyAfterDisconnecting:"失联后转待机的时长",
					standbyAfterDisconnectingTip:"设备失联后，自动转为待机状态，需要设备具有相应的自治能力。0、-1：不具备能力，默认值：-1。",
					maxEnvTemperature:"环境温度上限",
					minEnvTemperature:"环境温度下限",
					maxEnvHumidity:"环境湿度上限",
					minEnvHumidity:"环境湿度下限",
					maxPcsCoolerTemperature:"PCS散热器最高温度",
					maxBmsCellTemperature:"Rack单体温度的最高值",
					minBmsCellTemperature:"Rack单体温度的最低值",
					maxAverageBmsCellTemperature:"Rack平均温度最高值",
					minGridFrequency:"电网频率最小值",
					minGridFrequencyTip:"单位：0.001Hz。允许的数值范围：49.5 * 1000 - 50.5 * 1000，默认值：49500。",
					maxGridFrequency:"电网频率最大值",
					maxGridFrequencyTip:"单位：0.001Hz。允许的数值范围：49.5 * 1000 - 50.5 * 1000，默认值：50500。",

					
				},
				modeBus:{
					setDeviceProp:"配置设备的能力集",
					addDeviceProp:"增加设备能力",
					
					isDel:"是否删除该寄存器位置?",
					
					registerStart:"起始地址",
					registerLength:"地址长度",
					slaveNo:"从站号",
					opCode:"功能码",
					bizAction:"设备能力",
					readStatus:"读取实时运行参数",
					
					opCodeType:{
						readHoldingRegister:"读取保持寄存器(0x03)",
						readInputRegister:"读取输入寄存器(0x04)",
						writeToHoldRegister:"写入保持寄存器(0x06)"
					}
				},
				iec104:{
					title:"信息点",
					setDeviceProp:"配置设备的能力集",
					addDeviceProp:"增加设备能力",
					isDel:"是否删除该信息点?",
					coa:"公共地址",
					ioa:"信息点地址",
					dataType:"数据类型",
					bizAction:"设备能力",
					
					generalInterrogation:"总召唤",
					singleInterrogation:"单点召唤",
					groupInterrogation:"分组召唤",
					mixedMode:"混合模式",
					
					yes:"是",
					no:"否",
					
					strange:"奇",
					occasionally:"偶",
					None:"无",
					
					iec104DataType:{
						M_SP_NA_1:'单点值',
						M_SP_TB_1:'CP56Time2a单点值',
						M_DP_NA_1:'双点值',
						M_DP_TB_1:'CP56Time2a双点值',
						M_ME_NA_1:'归一化值',
						M_ME_TD_1:'CP56Time2a归一化值',
						M_ME_NB_1:'标度化值',
						M_ME_TE_1:'CP56Time2a标度化值',
						M_ME_NC_1:'短浮点值',
						M_ME_TF_1:'CP56Time2a短浮点值',
					}
				}
			},
			deviceType:{
				name:"设备类型名称",
				no:"设备类型代号",
				description:"类型描述"
			},
			deviceFactory:{
				name:"设备厂商名称",
				no:"设备厂商代号",
				description:"厂商描述"
			},
			deviceModel:{
				name:"设备型号名称",
				no:"设备型号代号",
				description:"型号描述"
			},
			status:{
				title:"设备状态",
				active:"正常",
				error:"故障",
				alarm:"置疑",
				unRegister:"未注册",
				register:"注册",
				cancelRegister:"撤销",
				disabled:"禁用"
			},
			event:{
				title:"设备事件",
				null:"暂无设备事件"
			},
			whm:{
				title:"电表详细",
				stationId:"从站编号",
				potentialTransformer:"电压变比",
				currentTransformer:"电流变比",
				
				current:"电流",
				currentA:"A相电流",
				currentB:"B相电流",
				currentC:"C相电流",
				
				voltage:"电压",
				voltageA:"A相电压",
				voltageB:"B相电压",
				voltageC:"C相电压",
				
				addTodayData:"今日增量",
				positiveActiveEnergy:"正向有功电能",
				negativeActiveEnergy:"反向有功电能",
				total:"总",
				tsim:"尖",
				peak:"峰",
				flat:"平",
				valley:"谷",
				
				
				powerFactor:"功率因素",
				
			},
			pvi:{
				outputPower:"输出功率",
				todatQuantity:"发电量",
				pviWorkStatus:'逆变器工作状态',
				pviChart:"能源流向",
				queryStatus:"查询实时参数",
				todayEngry:"今日发电",
				event:"设备事件",
				control:"设备控制",
				setOutputPowerPercent:"调整功率比例",
				outputPowerPercent:"功率比例",
				setControlFactor:"调整功率因数",
				controlFactor:"功率因数",
				open:"开机",
				close:"关机",
				data:"设备数据",
				history:"历史数据",
				status:{
					standby:"待机中",
					work:"工作中",
					null:"未知",
					
					current:"电流",
					currentA:"A相电流",
					currentB:"B相电流",
					currentC:"C相电流",
					
					voltage:"电压",
					voltageA:"A相电压",
					voltageB:"B相电压",
					voltageC:"C相电压",
					
					power:"功率",
					powerRatio:"功率比值",
					powerFactor:"功率因素",
					
					env:"机内环境",
					temperature:"机内温度",
					
					engry:"发电量",
					totalEngry:"总发电量",
					todayEngry:"今日发电"
				},
				
			}
		},
		envData:{
			title:"环境贡献",
			treesaving:"等效植树",
			energysaving:"减少排放",
			cosaving:"CO₂减排",
			treeUnit:"棵",
			tin:"吨"
		},
			
		logintab: {
			text: "SHE - SmartHomeEndpoint",
			untip: "请输入账户",
			pwtip: "请输入密码",
			identify:"请输入验证码",
			nullParmter:"请输入账号、密码、验证码",
			
			copyrightDate: "江苏合力四通智能科技股份有限公司 © 2025",
			copyrightText:"备案号：",
			companyPhone:"咨询热线：0511-85336035",
			companyEmail:"邮箱：admin@helist.com.cn",
			companyAddres:"地址：江苏省镇江市新区丁卯扬帆路10号",
			bottomtip3:"技术支持：江苏合力四通",
			
			logintext: "登 录"
		},
		//通知框
		notify:{
			notify:"通知",
			title:"提示",
			reslut:"执行结果",
			nullParmter:"必要参数未填写",
			delText:"此操作不可逆，是否继续?"
		},
		user:{
			changepw:"修改密码",
			exit:"退出登录",
			newPassword:"新密码",
			confirmPassword:"确认密码"
		},
		//404页面
		notFind:{
			title:"404 提示",
			text:"你的页面走丢了",
			nullParmter:"请输入账号和验证码"
		},
		//首页
		mainView:{
			emptyTip:'暂无数据',
			//设备运行
			runInformation:{
				title:"设备运行",
			},
			//运维分析
			deviceManage:{
				title:"运维分析",
				month:"月",
				day:"日",
				year:"年",
				repair:{finish:"已抢修",noFinish:"待抢修"},
				check:{finish:"已巡检",noFinish:"待巡检"}
			},
			envData:{
				title:"环境贡献",
			},
			
			//光伏数据分析
			loadphotovoltaic:{
				title:'光伏数据分析',
				key:"光伏",//用于筛选出光伏电表
				charger:"发电",
				disCharger:"余电上网"
				
			},
			//储能数据分析
			loadEnergy:{
				title:'储能数据分析',
				key:"储能",//用于筛选出储能电表
				charger:"充电",
				disCharger:"放电"
			},
			//最新工单
			newestOrder:{
				title:"最新工单",
				null:"暂无运维工单"
			},
			//告警信息
			alarmMessage:{
				title:"项目事件",
				null:"暂无告警信息"
			},
			//当月告警排行
			alarmTop:{
				title:"当月告警排行",
				null:"暂无当月告警排行"
			}
		},
		menuContainer:{
			topMenu: {
				logotext: "智能家用管理后台",
			},
		},
		//项目监控
		projectMonitor:{
			select:{
				deviceType:"筛选:设备类型",
				deviceGroup:"筛选:设备群组",
				deviceModel:"筛选:设备型号",
				searchKey:"搜索关键字"
			},
		},
		//设备群组和设备区域
		subarea:{
			deviceArea:{
				placeholder:"请输入设备区域名称",
				add:"新建设备区域",
				edit:"编辑设备区域",
				delTip:"是否确定删除当前设备区域？",
				areaName:"区域名称",
				areaNo:"区域代号",
				areaAddres:"区域地址",
				areaLocation:"地理数据",
				createTime:"创建时间",
				areaDescription:"区域描述",
				areaDo:"区域操作",
				city:"所在城市"
			},
			deviceGroup:{
				placeholder:"请输入设备群组名称",
				delTip:"是否确定删除当前设备群组？",
				add:"新建设备群组",
				edit:"编辑设备群组",
				groupName:"群组名称",
				groupNo:"群组代号",
				groupAddres:"群组地址",
				groupLocation:"地理数据",
				createTime:"创建时间",
				groupDescription:"群组描述",
				groupDo:"群组操作",
				gourpStatus:"群组状态",
				area:"所属区域"
			}
		},
		//已废弃
		createDevice:{
			next:"下一步",
			back:"上一步",
			
		},
		//管理日志 操作日志 访问日志 用户日志
		log:{
			manage:{
				title:"管理日志",
				
			},
			operationLogs :{
				title:"操作日志"
			},
			visithistories :{
				title:"访问日志"
			},
			userActivityLog :{
				title:"用户日志"
			}
		},
		
		
		project:{
			projectName:"项目名称",
			projectNo:"项目代号",
			
			city:"城市",
			location:"地理位置",
			createTime:"创建日期",
			
			role:{
				title:"角色信息",
				roleName:"角色名称",
				roleNo:"角色代号",	
				project:"所属项目",
				device:{
					deviceManage:"设备管理",
					deviceFactory:"设备厂商",
					deviceModel:"设备型号",
					deviceArea:"设备区域",
					deviceGroup:"设备群组",
					deviceList:"智能设备"
				},
				analysisAndOrder:{
					analysisAndOrderLabel:"分析与报表",
					historyAnalysis:"能效分析"
				},
				log:{
					title:"日志审计",
					
				},
				authValue:{
					null:"N/A",
					Audit:"审核",
					Browse:"浏览",
					edit:"编辑"
				}
			},
			member:{
				userName:"账户名称",
				passwd:"账户密码",
				phone:"电话号码",
				realName:"真实姓名",
				userRole:"用户角色",
				project:"所属项目",
				loginTime:"登录时间",
			}
		},
		projectSource:{
			saveParam:"保存参数",
			nullParam:"暂无参数被更改",
			languagePlaceholder:"请选择通知语言",
			message:{
				//通用配置
				general:{
					title:"通用配置",
					zone:"项目时区",
					zoneTip:"工程项目所在地区的时区，范围: -12 - 12。",
				},
				
				webParams:{
					general:{
						CommonOnceLoadRows:"单次加载行数",
						CommonOnceLoadRowsTip:"每次加载数据时系统返回的记录数量，默认值是：25。",
						

						HttpRequestTimeout: 'HTTP访问请求超时',
						HttpRequestTimeoutTip: '执行HTTP访问时，请求目标服务上指定资源的最大时长，单位：秒，允许的数值范围：5 - 180。',

						HttpConnectTimeout: 'HTTP访问连接超时',			  
						HttpConnectTimeoutTip: '执行HTTP访问时，连接目标服务器的最大时长，单位：秒，允许的数值范围：5 - 180。',
						
						CommonOnceLoadHistoryRows: '单次加载日志行数',
						CommonOnceLoadHistoryRowsTip: '每次加载日志数据时系统返回的记录数量，默认值是：50。',

						SystemTimezone: '系统数据库时区',
						SystemTimezoneTip: '系统数据库采用的时区设置，范围: -12 - 12。',
						
						HttpSocketTimeout: 'HTTP访问读取响应超时',
						HttpSocketTimeoutTip: '执行HTTP访问时，读取目标服务响应的资源的最大时长，单位：秒，允许的数值范围：5 - 180。',
					},
					message:{
						SystemMessageAdmin: '系统消息源用户',
						SystemMessageAdminTip: '指定发送系统消息时的源用户。',
						
						MailServerAddress: '邮箱SMTP服务器地址',
						MailServerAddressTip: '电子邮箱服务商的域名或地址，可以添加服务端口。',

						MailServerSmtpPort: 'SMTP端口',
						MailServerSmtpPortTip: '邮箱SMTP服务器的端口。',
						
						MailServerSmtpsPort: 'SMTP SSL 端口',
						MailServerSmtpsPortTip: '邮箱SMTP服务器的SSL端口。',


						MailSmtpValidate: 'SMTP身份验证',				  
						MailSmtpValidateTip: 'SMTP发送邮件时，是否需要身份验证。',
						
						MailSender: '系统管理员邮箱',					
						MailSenderTip: '系统消息通知邮件的发送者邮箱，系统将通过该邮箱发送邮件。',
						
						MailSenderAccount: '系统管理员邮箱账号',
						MailSenderAccountTip: '登录发送者邮箱的用户名。',

						MailSenderPassword: '系统管理员邮箱密码',
						MailSenderPasswordTip: '登录发送者邮箱的账户的授权码，不是账号的密码。',

						SmsHistoryExpired: '短信发送记录持久时间',
						SmsHistoryExpiredTip: '短信发送记录在数据库中保存的时长，单位：天。',
					},
					hly:{
						BizPressText:"水印文字",
						BizPressTextTip:"自动为上传的图片添加水印文字；如果留空，则表示添加水印文字；水印文字不支持分行，最多允许10个字母、数字或中文。",

						BizCountUploadImages:"上传图片数量的最大值",
						BizCountUploadImagesTip:"在每个工程项目中，允许上传图片的最大值，默认值：50，最大值：100。",
						
						
						ProjectScanFrequency:"项目计划任务扫描频率",
						ProjectScanFrequencyTip: '对项目内设备的活跃状态进行固定频率检测，允许的数值范围：1秒 - 3600秒，默认值：60秒。',
						
						
						DeviceHeartBeatFrequencyMin: '心跳频率的最小值',
						DeviceHeartBeatFrequencyMinTip: '检测设备活跃状态的频率的最小值。单位：秒。默认值：180。',
												
												
						DeviceHeartBeatFrequencyMax:'心跳频率的最大值',
						DeviceHeartBeatFrequencyMaxTip: '检测设备活跃状态的频率的最大值。单位：秒。默认值：7200。',
						
						DeviceHeartBeatFrequency: '心跳频率',					  
						DeviceHeartBeatFrequencyTip: '检测设备活跃状态的频率的默认值。单位：秒。默认值：300。',
						
					
						DeviceActiveAttemptionTitle: '设备心跳检测尝试次数',
						DeviceActiveAttemptionTip: '当设备活跃状态检测失败指定次数后，状态被强制修改为错误，直到状态检测成功。默认值：10。',
						
						PersistenceStatusActive: '设备心跳数据持久时间',
						PersistenceStatusActiveTip: '设备活跃状态数据在数据库中保存的时长，单位：天。允许的数值范围：3 - 90，建议值： 7。',
						
					}
				},
				
				//通知类
				notice:{
					NoticeLanguage:"消息通知语言",
					NoticeLanguageTip:"系统生成的通知消息所使用的语言类型",
					SmsTitle:"手机短信参数配置",
					SmsTip:"接收短信的号码",
					EmailTitle:"电子邮箱参数配置",
					EmailTip:"接收通知的邮箱",
					
					noticeRule:"消息通知配置",
					webNotice:"网站通知",
					phoneNotice:"手机短信",
					emailNotice:"电子邮件",
					userChange:"账号变化",
					deviceStatus:"设备状态"
				},
				//云端配置
				hly:{
					title:'云端配置',
				    CountUploadImages: "最大上传图片数",
				    CountUploadImagesTip: "单次最多上传100张图片（默认50）",
				    
				    PressText: "图片水印文字",
				    PressTextTip: "可为图片添加水印（限10个字符，不支持换行）",
				    
				    ProjectScanFrequency: "计划任务扫描频率",
				    ProjectScanFrequencyTip: "设备活跃状态检测间隔（1-3600秒，默认60秒）",
				    
				    DeviceHeartBeatFrequency: "心跳检测频率",
				    DeviceHeartBeatFrequencyTip: "设备心跳检测间隔（默认300秒）",
				    
				    DeviceActiveAttemption: "心跳失败阈值",
				    DeviceActiveAttemptionTip: "连续失败10次标记为故障状态",
				    
				    PersistenceStatusActive: "心跳数据保留时长",
				    PersistenceStatusActiveTip: "活跃状态数据保存3-90天（建议7天）",
				    
				    PersistencePivHistoryElectricity: "光伏数据保留时长",
				    PersistencePivHistoryElectricityTip: "逆变器分时记录保存1-365天（默认30天）"
				},
				ems:{
					title:"场站端",
					
					  // 基础配置
					  EmsId: "EMS系统标识码",
					  EmsIdTip: "由系统管理员分配的唯一标识码，有效范围：1000 - 9999",
					
					  // 安全与运行配置
					  EmsSecurityLevel: "EMS安全等级",
					  EmsSecurityLevelTip: "定义系统安全级别：0-标准模式（默认） | 1-增强模式 | 2-高级模式",
					
					  EmsRunMode: "EMS运行模式",
					  EmsRunModeTip: "控制系统运行方式：0-策略自动模式（默认） | 1-手动控制模式",
					
					  EmsEmergencyStopMode: "EMS急停模式",
					  EmsEmergencyStopModeTip: "急停触发时的处理方式：0-高压分闸（默认） | 1-变流器停机",
					
					  // 通信配置
					  EmsReadRegisterAttemption: "寄存器读取重试次数",
					  EmsReadRegisterAttemptionTip: "设备寄存器读取失败时的最大重试次数，范围：0-100次（默认3次）",
					
					  EmsWriteRegisterAttemption: "寄存器写入重试次数",
					  EmsWriteRegisterAttemptionTip: "设备寄存器写入失败时的最大重试次数，范围：0-100次（默认2次）",
					
					  // 充电验证配置
					  EmsValidateChargeAttemption: "充电许可验证重试次数",
					  EmsValidateChargeAttemptionTip: "充电条件验证失败时的重试次数，范围：0-100次（默认3次）",
					
					  EmsValidateChargeDuration: "充电许可验证频率",
					  EmsValidateChargeDurationTip: "切换至充电参数验证的时间间隔：1000-60000毫秒（默认3000ms）",
					
					  // 放电验证配置
					  EmsValidateDischargeAttemption: "放电许可验证重试次数",
					  EmsValidateDischargeAttemptionTip: "放电条件验证失败时的重试次数，范围：0-100次（默认3次）",
					
					  EmsValidateDischargeDuration: "放电许可的检测频率",
					  EmsValidateDischargeDurationTip: "切换至放电参数验证的时间间隔：1000-60000毫秒（默认3000ms）",
					
					  // 功率调节配置
					  EmsAdjustDischargingPowerFrequency: "放电功率调节频率",
					  EmsAdjustDischargingPowerFrequencyTip: "放电功率调整的时间间隔：1000-60000毫秒（默认1000ms）",
					  
					  EmsAdjustChargingPowerFrequency:"充电功率调节频率",
					  EmsAdjustChargingPowerFrequencyTip:"充电功率调整的时间间隔：1000-60000毫秒（默认1000ms）",
					  
					  EmsMinIntervalBetweenChargeAndDischarge: "充放电切换最小间隔",
					  EmsMinIntervalBetweenChargeAndDischargeTip: "充放电状态切换的最小时间间隔：300-1800秒（默认600秒）",
					
					  // 功率分配配置
					  EmsChargingPowerDistributionType: "充电功率分配策略",
					  EmsChargingPowerDistributionTypeTip: "多设备充电功率分配方式：0-平均分配（默认） | 1-抢占式分配",
					
					  EmsReDistributeDischargingPowerBetweenAmus: "放电功率再分配",
					  EmsReDistributeDischargingPowerBetweenAmusTip: "是否在多计量单元间调配放电功率：0-不调配 | 1-调配（默认）",
					
					  EmsPreservedActivePowerDischarge: "电网保留有功功率",
					  EmsPreservedActivePowerDischargeTip: "放电时保留的电网最低有功功率：0-2147483647W（默认0）",
					
					  EmsDischargingPowerDistributionType: "放电功率分配策略",
					  EmsDischargingPowerDistributionTypeTip: "多设备放电功率分配方式：0-平均分配（默认） | 1-抢占式分配",
					
					  // 计量单元配置
					  EmsAmuMatchType: "计量单元匹配模式",
					  EmsAmuMatchTypeTip: "计量单元计算方式：0-包含所有计量单元（默认） | 1-精确匹配带储能设备的计量单元",
					
					  // 系统日志配置
					  EmsLogLevel: "系统日志等级",
					  EmsLogLevelTip: "日志记录详细程度：0-基础日志 | 1-增强日志（默认） | 2-详细日志",
					  
					  EmsRuntimeStrictMode:"设备Runtime的严格模式",
					  EmsRuntimeStrictModeTip:"EMS在创建设备实时运行参数时的严格模式。0：一般；1：严格。默认值：1。",
					  
					  EmsHistoryRuntimeFrequency:"设备实时运行参数日志的持久化频率",
					  EmsHistoryRuntimeFrequencyTip:"设备实时运行参数日志的持久化频率，单位：秒。允许的数值范围：30 - 300，默认值：60。",
					  
					  EmsHistoryKeyFrequency:"设备关键参数的日志持久化频率",
					  EmsHistoryKeyFrequencyTip:"设备关键运行参数日志的持久化频率，单位：秒。允许的数值范围：1 - 300，默认值：30。",
					  
					  EmsPublishSkrtToHly:"同步设备关键参数至云端",
					  EmsPublishSkrtToHlyTip:"按照设定的频率，向云端发布场站端的设备关键参数。允许的数值范围：0 - 1，默认值：0。",
					  
					  EmsAmuMaxDemandRelatedDays:"最大需量的参考天数",
					  EmsAmuMaxDemandRelatedDaysTip:"从近期数据中，取辅助计量单元的有功功率最大值，作为其上月最大需量。允许范围：1 - 180，默认值：30天。",
					  
					  EmsAmuMaxDemandDuration:"最大需量的有效时长",
					  EmsAmuMaxDemandDurationTip:"最大需量时在缓存中的存活时长,允许的数值范围：5 - 86400，默认值：600秒。"
					  
				}
			},
		},
		//ems 策略
		emsPolicy:{
			deviceList:"储能设备列表",
			policyChart:"策略示例图",
			demoPolicy:'策略示例数据',
			editPolicy:'编辑策略',
			importPolicy:"导入策略",
			isSendPolicy:"确定下发控制策略?",
			sendPolicy:"下发策略",
			removePolicy:"移除策略单元",
			addPolicy:"新增策略单元",
			savePolicy:"保存策略信息",
			searchTip:"输入关键字进行过滤",
			charge:"充电",
			discharge:"放电",
			standby:"待机",
			policy:{
				policyName:"策略名称",
				startTime:"开始时间",
				endTime:"结束时间",
				opType:"执行操作",
				maxActivePower:"最大功率",
				period:'时间范围',
				max:"无限制",
				force:{
					title:"是否强启",
					falseText:"保持",
					trueText:"强启"
				},
				enable:{
					title:"是否启用",
					falseText:"否",
					trueText:"是",
					enableText:"启用",
					unEnable:"未启用"
				},
				maxSoc:"SOC限值",
			},
			policyUnit:{
				title:"策略单元",
				
				opType:"操作类型",
				
				timePlaceholder:"选择时间范围",
				
			}
		},
		//ems 组态
		emsWeb:{
			projectWeb:"项目组态",
			project:"所属项目"
		},
		//能效分析
		historyAnalysis:{
			searchTip:"输入关键字进行过滤",
			dayData:"汇总数据",
			hourData:"分时数据",
			monthData:"每月统计",
			timeManage:"分配时段",
			emptyTip:'暂无数据渲染',
			positiveActiveEnergy:"正向增量",
			NegativeActiveEnergy:"反向增量",
			timePeriod:"时间段",
			time:"时间",
			total:"总计",
			timeManageForm:{
				title:"时段配置",
				name:"时段名称",
				range:"时段范围",
				addTime:"新增时段",
				saveTime:"保存时段"
			}
		},
		//项目事件
		projectEvent:{
			eventTime:"事件时间",
			eventLevelPlaceholder:"请选择事件等级",
			sreachKey:"请输入内容",
			eventNo:"事件编号",
			createTime:"产生时间",
			eventLevel:"风险等级",
			eventTable:{
				deviceName:"设备名称",
				deviceNo:"设备代号",
				typeName:"设备类型",
				deviceGroupName:"所属群组",
				eventDetail:"事件详细",
				timeOld:"前一次采集的时间",
				timeNew:"当前采集的时间",
				valueOld:"前一次数值",
				valueNew:"当前数值",
				eventDescription:"事件描述",
				solution:"解决方案",
				riskLevelOp:{
					info:"一般",
					badly:"严重",
					danger:"危险"
				}
			}
		},
		//侧边菜单
		menu:{
			mainview:'首页',
			setSystem:'系统配置',
			setPermission:'权限配置',
			systemProject:'工程项目',
			systemRole:'用户角色',
			systemUser:'用户管理',
			systemPermissions:'角色权限',
			systemSettings:'系统参数配置',
			setProject:'项目配置',
			userRole:'角色与成员',
			projectRole:'项目角色',
			projectMember:'项目成员',
			projectPermissions:'项目角色权限',
			message:'消息配置',
			setProjectParameter:'项目参数配置',
			
			emsTools:"场站工具",
			editEmsSystem:"编辑场站组态",
			editStationKeyRuntime:"编辑场站关键数据",
			editStationEvent:"编辑场站事件",
			
			deviceManage:'设备管理',
			baseDada:'基础数据',
			deviceType:'设备类型',
			deviceFactory:'设备厂商',
			deviceModel:'设备型号',
			stationRunStatus:"电站概括",
			projectMonitor:'项目监控',
			subarea:'设备分区',
			emsPolicy:'场站策略',
			
			hem:"家庭电站",
			hemCusomerType:"客户类型",
			hemCusomer:"客户列表",
			hemSuiteModel:"设备套件型号",
			hemSuite:"设备套件",
			hemHistoryStation:"场站日志",
			
			
			vpp:"虚拟电厂",
			// energyMarket:"交易大厅",
			// energyInformation:"消息报送",
			// orderInformation:"合约信息",
			// customerServer:"客户服务",
			
			
			data:'数据统计',
			historyAnalysis:'能效分析',
			checkLog:'​​日志审计​​',
			projecteEvent:'项目事件',
			log:'项目日志',
			emsWeb:'场站组态',
			
			
			mapView:'智慧能源',
		},
		
		//参数检查
		checkParameter:{
			edit:{
				deviceId: "设备编码不能为空",
				deviceIdLength: "设备编码固定长度为12个字符",
				deviceName: '设备名称不能为空',
				deviceNameLength:'设备名称长度不能少于2个字符',
				deviceNo: '设备代号不能为空',
				deviceNolength: '设备代号长度不能少于3个字符',
				deviceType: '设备类别不能为空',
				deviceModel: '设备型号不能为空',
				deviceGroup: '设备群组不能为空', 
				
				protocolVersion:"协议版本不能为空",
				
				udpPort:"服务端口不能为空",
				
				dtuDeviceId:"上行中继不能为空",
				modbusSlaveNo:"从站号不能为空",
				potentialTransformer:"电流变比不能为空",
				currentTransformer:"电流变比不能为空",
				
				serverAddress: '通讯地址不能为空',
				serverPort: '服务端口不能为空',
				serialPortName: '串口名称不能为空',
				baudRate: '波特率不能为空',
				dataBit: '数据位不能为空',
				stopBit: '停止位不能为空',
				parityCheck: '帧校验不能为空',
				intervalMonitor: '监测周期不能为空',
				frameCheck: '未选择帧校验', 
				broadcastEnable: '未选择监听广播',
				
				comProtocol: '通讯协议未选择',
				coa: '公共地址不能为空',
				interrogationType: '召唤方式未选择',
				useMultiThreads: '线程方式未选择',
				
				
				dischargeAmuDeviceId: '未选择放电计量单元',
				chargeAmuDeviceId: '未选择充电计量单元',
				
				bcpDeviceId: '未选择电池舱',
				bcpstackDeviceId: '未选择电池堆',
			}
		}
		
		
	}
}